import axios from "axios"

export interface SendTriiboOtpInput {
  cellphone?: string
  email?: string
  type: "whatsapp" | "email"
}

export interface SendTriiboOtpResponse {
  error?: boolean
  success?: {
    transactionId?: string
  }
  message?: string
  errorCode?: number
}

export interface ValidateTriiboOtpInput {
  code: string
  cellphone: string
  transactionId: string
  ckt?: boolean
}

export interface ValidateTriiboOtpResponse {
  success?: boolean
  redirect?: string
  data?: {
    status?: string
    logged_in?: boolean
    triiboId?: string
    action?: string
    phone?: string
  }
  error?: {
    errorCode?: number
    message?: string
  }
}

export interface CompleteTriiboRegistrationInput {
  cellphone: string
  email: string
  password: string
  triiboId?: string
  terms: boolean
  ckt?: boolean
}

export interface CompleteTriiboRegistrationResponse {
  success?: boolean
  redirect?: string
  data?: {
    status?: string
  }
  error?: {
    code?: number
    message?: string
  }
}

const OTP_ERROR_MESSAGES: Record<number, string> = {
  1006: "Codigo invalido.",
  1007: "Codigo expirado.",
  1009: "Celular invalido.",
}

const GENERIC_OTP_ERROR_MESSAGE = "Nao foi possivel validar o codigo."

export const resolveWordPressOrigin = (wpApiUrl: string): string => {
  const parsedUrl = new URL(wpApiUrl)
  return parsedUrl.origin
}

export const buildAdminAjaxUrl = (origin: string): string => {
  return `${origin}/wp-admin/admin-ajax.php`
}

export const getOtpErrorMessage = (errorCode?: number): string => {
  if (!errorCode) {
    return GENERIC_OTP_ERROR_MESSAGE
  }

  return OTP_ERROR_MESSAGES[errorCode] ?? GENERIC_OTP_ERROR_MESSAGE
}

export const sendTriiboOtp = async ({
  type,
  cellphone,
  email,
}: SendTriiboOtpInput): Promise<SendTriiboOtpResponse> => {
  const { data } = await axios.post<SendTriiboOtpResponse>(
    "/api/auth/triibo/send-otp",
    { type, cellphone, email }
  )
  return data
}

export const validateTriiboOtp = async ({
  cellphone,
  code,
  transactionId,
  ckt,
}: ValidateTriiboOtpInput): Promise<ValidateTriiboOtpResponse> => {
  const { data } = await axios.post<ValidateTriiboOtpResponse>(
    "/api/auth/triibo/validate-otp",
    { cellphone, code, transactionId, ckt }
  )
  return data
}

export const completeTriiboRegistration = async ({
  cellphone,
  email,
  password,
  terms,
  ckt,
  triiboId,
}: CompleteTriiboRegistrationInput): Promise<CompleteTriiboRegistrationResponse> => {
  const { data } = await axios.post<CompleteTriiboRegistrationResponse>(
    "/api/auth/triibo/complete-registration",
    { cellphone, email, password, terms, ckt, triiboId }
  )
  return data
}
